import { Skeleton } from '@mui/material';

const AccessManagementLoadingSkeleton = () => {
  return Array.from({ length: 3 }, (_, rowInd) => {
    return (
      <div key={rowInd} className='flex-1'>
        {Array.from({ length: 4 }, (__, colInd) => {
          return <Skeleton className='my-[8px]' key={colInd} variant='rounded' height={20} />;
        })}
      </div>
    );
  });
};

export default AccessManagementLoadingSkeleton;
